<template>
  <Transition name="tonibart-route-loader-fade">
    <div
      v-if="isLoading"
      class="tonibart_route-loader"
      role="status"
      aria-label="A carregar"
    >
      <div class="tonibart_route-loader_bar"></div>
      <img
        class="tonibart_route-loader_spinner"
        src="@/assets/img/af-loading.svg"
        alt=""
        width="70"
        height="40"
      />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useRouteLoading } from "@/composables/useRouteLoading";

const { isLoading } = useRouteLoading();
</script>

<style scoped>
/* Cobre a página inteira enquanto a rota resolve e/ou a página vai buscar
   os seus dados iniciais (ver manterCarregandoEnquanto). */
.tonibart_route-loader {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tonibart-bg, #f5f8f6);
}

.tonibart_route-loader_bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  overflow: hidden;
}

.tonibart_route-loader_bar::after {
  content: "";
  display: block;
  height: 100%;
  width: 40%;
  background: linear-gradient(
    90deg,
    transparent,
    var(--bs-primary, #0f8a5f),
    transparent
  );
  animation: tonibart-route-loader-sweep 1.1s ease-in-out infinite;
}

.tonibart_route-loader_spinner {
  opacity: 0.85;
}

@keyframes tonibart-route-loader-sweep {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(250%);
  }
}

.tonibart-route-loader-fade-enter-active,
.tonibart-route-loader-fade-leave-active {
  transition: opacity 0.2s ease;
}
.tonibart-route-loader-fade-enter-from,
.tonibart-route-loader-fade-leave-to {
  opacity: 0;
}
</style>
